export default __webpack_public_path__ + "static/bentoSectionBg4-eb02f07628f8a49107e7230ec1115f54.webp";